module.exports = __webpack_public_path__ + "425ca093a9fc0d7d814a0d6c2a39cece.png";